import {Component, OnInit} from '@angular/core';
import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {ProgressComponent} from './shared/progress/progress.component';
import {SharedService} from './shared/shared.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{
  isHandset = false;
  dialogRef: MatDialogRef<ProgressComponent> | undefined;

  constructor(private sharedService: SharedService, private dialog: MatDialog) {
    this.dialogRef = undefined;
  }

  ngOnInit() {
    this.sharedService.progressVisibilitySubject.subscribe(visible => {
      if (visible) {
        if (this.dialogRef === undefined) {
          const dialogConfig = new MatDialogConfig();
          dialogConfig.panelClass = 'loading-overlay';
          dialogConfig.disableClose = true;
          this.dialogRef = this.dialog.open(ProgressComponent, dialogConfig);
        }
      } else {
        if (this.dialogRef !== undefined) {
          this.dialogRef.close();
          this.dialogRef = undefined;
        }
      }
    });
  }
}
